<template>
  <v-row>
    <v-col cols="12" :class="labelClass">
        {{ label }}

        <v-tooltip top v-if="tooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" class="mb-1">mdi-information-outline</v-icon>
            </template>
            <span> {{ tooltip }}</span>
        </v-tooltip>
    </v-col>
    <v-col cols="12" :class="dataTextClass">
      <span v-if="data">{{ cptdData }}</span>
      <slot v-else/>
    </v-col>    
  </v-row>
</template>

<script>
  export default {
    name: 'HeaderDetailsRow',
    props: {
      label: {
        type: [String, Number, Object],
        default: '',
      },
      tooltip: {
        type: [String],
        default: ''
      },
      data: {
        type: [String, Number, Object, Array],
        default: '',
      },      
      labelClass: {
        type: Array,
        default() {
          return ['font-italic', 'pb-1']
        },
      },
      dataTextClass: {
        type: Array,
        default() {
          return ['font-weight-bold', 'pt-0', 'text-md-subtitle-1']
        },        
      }
    },
    methods: {
      emptyString(string) {
        return string ? string.trim() || ' - ' : ' - ';
      },
    },
    computed: {
      cptdData() {  
        if (['string', 'object'].includes(typeof this.data) && this.data.length > 0 ) {
          if (typeof this.data == 'string') {
            return this.emptyString(this.data)
          } else {
            return this.data.map(el =>  this.emptyString(el)).join(', ')
          }
        }
        return this.data
      }
    },
  }
</script>